import ChoiceIcon from '@material-ui/icons/ViewList';

import ChoiceList from './ChoiceList';
import ChoiceCreate from './ChoiceCreate';
import ChoiceEdit from './ChoiceEdit';

export default {
  list: ChoiceList,
  create: ChoiceCreate,
  edit: ChoiceEdit,
  icon: ChoiceIcon,
};
